export const getTypeMoney = (countryInitial: string)=>{
	switch (countryInitial) {
    case 'CHILE':
      return 'UF';
    case 'CONTEMPORA':
      return 'UF';
    case 'SPAIN':
      return '€';
    default:
      return '$';
  }
}